import React, { useState, useCallback, useRef, useEffect } from "react";
import { GoogleMap, Marker, StandaloneSearchBox } from "@react-google-maps/api";
import { useJsApiLoader } from "@react-google-maps/api";

const MyMapComponent = ({coordinates}) => {
    const latlong = localStorage.getItem('let_long');

    const [center, setCenter] = useState({
        lat: latlong?.lat ? latlong?.lat : 19.0759837,
        lng: latlong?.lng ? latlong?.lng : 72.8776559,
    });

    const [marker, setMarker] = useState(center);
    const searchBoxRef = useRef(null);

    useEffect(()=>{
        const location = {
          lat: parseFloat(coordinates?.lat),
          lng: parseFloat(coordinates?.lon),
        };
        
        setCenter({
          lat: location?.lat ? location?.lat : 19.0759837,
          lng: location?.lng ? location?.lng : 72.8776559,
        });

        setMarker({
          lat: location?.lat ? location?.lat : 19.0759837,
          lng: location?.lng ? location?.lng : 72.8776559,
        });
    },[coordinates?.lat]);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyA3BYK_Siw8ebziSskitaA5YMjbvcO6n4U",
        libraries: ["places"], // Add Places API
    });

    const onUnmount = useCallback(function callback() {
        setMarker(null);
    }, []);

    const onPlacesChanged = () => {
        const places = searchBoxRef.current.getPlaces();
        const place = places[0];
        if (place) {
            const location = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            setCenter(location);
            setMarker(location);
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            getAddressFromLatLng(lat, lng);
        }
    };

    const handleMapClick = (event) => {
        const { latLng } = event;
        const lat = latLng.lat();
        const lng = latLng.lng();
        setCenter({ lat, lng });
        setMarker({ lat, lng });
        getAddressFromLatLng(lat, lng);
    };

    const getAddressFromLatLng = async (lat, lng) => {
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}`
            );
            if (response.ok) {
                const data = await response.json();
                if (data?.results && data?.results.length > 0) {
                    const full_address = data?.results[0]?.address_components;
                    const location = full_address?.find((loc) =>
                        loc?.types?.includes("postal_code")
                    );
                    const location1 = data?.results[0]?.formatted_address;
                    const let_lng = data?.results[0]?.geometry?.location;
                    // Optional: update the state with address or pin code
                } else {
                    console.log("Address not found");
                }
            } else {
                console.log("Failed to fetch address");
            }
        } catch (error) {
            console.error("Error fetching address:", error);
        }
    };

    return (
        <>
            {isLoaded ? (
                <div className=" position-relative">
                    <StandaloneSearchBox
                        onLoad={(ref) => (searchBoxRef.current = ref)}
                        onPlacesChanged={onPlacesChanged}
                    >
                        <input
                            type="text"
                            placeholder="Search for places"
                            className="map-search-input"
                        />
                    </StandaloneSearchBox>

                    <GoogleMap
                        mapContainerStyle={{
                            height: "400px",
                            width: "100%",
                        }}
                        center={center}
                        zoom={13}
                        onUnmount={onUnmount}
                        onClick={handleMapClick}
                    >
                        {marker && <Marker position={marker} />}
                    </GoogleMap>
                </div>
            ) : (
                <div>Loading...</div>
            )}
        </>
    );
};

export default MyMapComponent;
